export default __webpack_public_path__ + "static/media/Account.78c8f742.svg";